export default __webpack_public_path__ + "static/media/about.b089fe6a.png";